import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/views/dashboard/Dashboard'
//import HelloWorld from '@/components/HelloWorld'


Vue.use(Router)

const router = new Router({
  routes: [
    // {
    //   path: '/',
    //   redirect: '/dashboard'
    // },
    {
      path: '/',
      component: Dashboard,
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: (resolve) => require(['@/views/home/Home'], resolve),
          meta: { title: '首页' }
        }
      ]
    },
    {
      path: '/mySalaryList',
      component: Dashboard,
      children: [{
        path: "/mySalaryList",
        name: 'mySalaryList',
        component: () => import('@/views/finance/MySalaryList'),
        meta: { title: '资产管理', access: 0 }
      }]
    },
    {
      path: '/system/user',
      component: Dashboard,
      children: [{
        path: "/system/user",
        name: 'user',
        component: () => import('@/views/system/User'),
        meta: { title: '系统管理/用户管理', access: 0 }
      }]
    },
    {
      path: '/login',
      name: 'Login',
      component: (resolve) => require(['@/views/login/Login'], resolve)
    }
  ]
})

//let EXPIRESTIME = 86400000
let EXPIRESTIME = 7200000

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  //如果去往登录页则放行 
  if (to.path === '/login') {
    next();
  } else {
    // 从本地存储里获取token
    let item = localStorage.getItem("token");
    try {
      item = JSON.parse(item);
    } catch (error) {
      item = item;
    }
    let date = new Date().getTime();
    // 判断token是否为空如果为空则跳转到登录页 如果有则放行
    if (item === null || item === '') {
      next({ path: '/login' });
    } else {
      if (date - item.startTime > EXPIRESTIME) {
        localStorage.removeItem('token');
        next({ path: '/login' });
      } else {
        next();
      }
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js